import { useState, useEffect } from 'react';

import { CallflowReadFields } from '@ragu-components/ord-types';
import { TextField } from 'react-admin';

import { flowchartLogger } from 'src/lib/logger';

import ResourceList from '../../components/ResourceList';
import NodeControlForm from '../NodeControlForm';

import type { NodeControlsProps } from '../../dataProvider/types';
import type { CallflowRead } from '@ragu-components/ord-types';

export interface GotoType extends Record<string, unknown> {
  goto: CallflowRead | null;
}

interface GotoControlsProps extends NodeControlsProps {
  updateNodeData: (data: Record<string, unknown>) => void;
  data: GotoType;
}

export default function GotoControls({ updateNodeData, data }: GotoControlsProps): React.ReactElement {
  const [goto, setGoto] = useState<CallflowRead | null>(data.goto ?? null);

  const onGotoDataUpdate = (event: React.FormEvent): void => {
    event.preventDefault();
    flowchartLogger.debug('GotoControls: onGotoDataUpdate', { goto });
    if (goto === undefined || goto === null) {
      flowchartLogger.debug('GotoControls: goto is undefined or empty. Update cancelled.');
      return;
    }
    updateNodeData({ goto });
  };

  useEffect(() => {
    flowchartLogger.debug('GotoControls: goto changed', { goto });
    updateNodeData({ goto });
  }, [goto, updateNodeData]);

  return (
    <NodeControlForm
      onSubmit={onGotoDataUpdate}
      isDisabled={goto === undefined || goto === null}
      data={data}
      updateNodeData={updateNodeData}
    >
      <ResourceList
        resource='callflows'
        selectedResourceId={goto !== null ? goto.id : null}
        filter={{ active: 'fiql', fiql: `latest_callflow_version.id=isnull=true` }}
        onRowClick={(_id, _resource, record) => {
          setGoto(record as CallflowRead);
          return false;
        }}
      >
        <TextField source={CallflowReadFields.name} />
        <TextField source={CallflowReadFields.priority} />
        <TextField source={CallflowReadFields.description} />
      </ResourceList>
    </NodeControlForm>
  );
}
